// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__u1Dtf","title":"Header_title__2_ZAD","side":"Header_side__3yRun"};